<template>
  <div class="d-slider">
    <div class="d-slider__label" v-if="label">{{ label }}</div>
    <div class="d-slider__wrapper" ref="refWrap">
      <div class="d-slider__part" :ref="'refPart'+i"
        v-for="i in pos.length+1"
        :key="i+100"
        :class="[i === pos.length+1 ? 'd-slider__part-last' : '']"
        :style="{ background: colors[i-1]}">
      </div>
      <div class="d-slider__drag-container" :ref="'refDrag'+index"
        v-for="(item, index) in pos"
        :key="index">
        <div class="d-slider__value">
          {{item/steps}}
        </div>
        <div class="d-slider__drag"
          @mousedown="startDrag($event, index)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pos: [],
      elemDragged: null,
      stepLen: null,
      startX: null,
      cb: null
    }
  },

  props: {
    initPos: {
      type: Array,
      required: true
    },
    steps: {
      type: Number,
      required: true
    },
    label: String,
    colors: Array
  },

  watch: {
    initPos () {
      this.pos = JSON.parse(JSON.stringify(this.initPos))
      setTimeout( () => {
        for(let i = 0; i<this.pos.length; i++) {
          this.setDragOnSlider(i)
        }
        this.setPartsWidth()
      }, 0)
    }
  },

  mounted () {
    this.pos = JSON.parse(JSON.stringify(this.initPos))
    this.cb = () => {
      setTimeout( () => {
        const wrapLen = this.$refs.refWrap.clientWidth
        this.stepLen = wrapLen/this.steps
        for(let i = 0; i<this.pos.length; i++) {
          this.setDragOnSlider(i)
        }
        this.setPartsWidth()
      }, 0)
    }
    window.addEventListener('resize', this.cb)
    this.cb()
  },

  beforeDestroy () {
    window.removeEventListener('mousemove', this.calcMove)
    window.removeEventListener('mouseup', this.stopDrag)
    window.removeEventListener('resize', this.cb)
  },

  methods: {
    getShowValue (index) {
      return this.pos[index]/this.steps
    },

    setDragOnSlider(index) {
      const offX = this.pos[index]*this.stepLen
      this.$refs['refDrag'+index][0].style.left = offX-4+'px'
    },

    setPartsWidth () {
      let width = this.pos[0]*this.stepLen
      this.$refs['refPart1'][0].style.width = width+'px'
      for(let i = 1; i<this.pos.length; i++) {
        width = this.pos[i]*this.stepLen - this.pos[i-1]*this.stepLen
        this.$refs['refPart'+(i+1)][0].style.width = width+'px'
      }
    },

    startDrag(e, index) {
      this.elemDragged = index
      this.startX = e.clientX
      let wrap = this.$refs.refWrap
      window.addEventListener('mousemove', this.calcMove)
      window.addEventListener('mouseup', this.stopDrag)
      //wrap.addEventListener('mouseout', this.stopDrag)
    },

    stopDrag() {
      let wrap = this.$refs.refWrap
      this.elemDragged = null
      this.startX = null
      window.removeEventListener('mousemove', this.calcMove)
      window.removeEventListener('mouseup', this.stopDrag)
      //wrap.removeEventListener('mouseout', this.stopDrag)
    },

    calcMove(e) {
      const dif = e.clientX - this.startX
      let jumps = Math.floor(dif/this.stepLen)
      if(jumps<0) jumps++

      if(this.elemDragged === 0 && this.pos[this.elemDragged] + jumps < 0) {
        jumps = -this.pos[this.elemDragged]
      }
      else if(this.elemDragged === this.pos.length - 1 && this.pos[this.elemDragged] + jumps > this.steps)
        jumps = this.steps - this.pos[this.elemDragged]
      else if(this.elemDragged != 0 && this.pos[this.elemDragged-1] > this.pos[this.elemDragged] + jumps) {
        jumps = this.pos[this.elemDragged] - this.pos[this.elemDragged-1] - 1
        if(jumps != 0) jumps *= -1
      }
      else if(this.elemDragged != this.pos.length-1 && this.pos[this.elemDragged+1] < this.pos[this.elemDragged] + jumps)
        jumps = this.pos[this.elemDragged+1] - this.pos[this.elemDragged] - 1

      if(jumps === 0) return
      this.startX += jumps*this.stepLen
      this.pos[this.elemDragged] += jumps
      this.setDragOnSlider(this.elemDragged)
      this.setPartsWidth()
      this.$emit('change', this.pos)
    }
  }
}
</script>

<style lang="scss">
.d-slider {
  &__label {
    @include labelStyle();
    margin-bottom: 30px;
  }

  &__wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

  &__part {
    border-radius: 2px;
    background: white;
    height: 10px;
  }

  &__part-last {
    flex-grow: 1;
  }

  &__drag-container {
    position: absolute;
  }

  &__drag {
    border-radius: 2px;
    width: 6px;
    height: 20px;
    background: white;
    border-style: solid;
    border-width: 1px;
    border-color: black;
    cursor: pointer;
  }

  &__value {
    font-size: 0.8em;
    position: absolute;
    top: -16px;
    left: 1px;
    user-select: none;
  }
}
</style>
